import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  useTheme,
} from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'
import Colors from '../../../utils/colors.json'

const styles = (theme: any) => ({
  card: {
    borderRadius: '20px',
    backgroundColor: theme.palette.primary.light,
    padding: '10px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.customColors.textColorSecondary,
  },
  value: {
    fontSize: '14px',
    fontWeight: 500,
    // color: '#1a1a1a',
  },
  blueValue: {
    fontSize: '14px',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
  circleDot: {
    width: '5px',
    height: '5px',
    backgroundColor: Colors.CIRCLE_DOT_COLOR,
    borderRadius: '50%',
    display: 'inline-block',
  },
})

const PolicyDetailsCard: React.FC = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <CardContent>
        <Typography
          variant='subtitle1'
          pb={1.5}
          fontSize={'14px'}
          fontWeight={400}
          color={Colors.TEXT_COLOR_SECONDARY}
        >
          Policy Details
        </Typography>
        <Box
          display={'flex'}
          flexDirection={'row'}
          // justifyContent={'space-between'}
          flexWrap={'wrap'}
          rowGap={2}
          columnGap={3.2}
        >
          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Policy Name</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={classes?.value}>
              Ayuvu Bharosa Vajra
            </Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Start Date</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={classes?.value}>12/12/2024</Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>End Date</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={classes?.value}>12/12/2024</Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Policy Tenure</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={classes?.value}>1 Year</Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Premium Paid</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={`${classes?.value} ${classes?.blueValue}`}>
              ₹ 12,000
            </Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Sum Insured</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={`${classes?.value} ${classes?.blueValue}`}>
              ₹ 5 Lakhs
            </Typography>
          </Box>

          <Divider flexItem orientation='vertical' />

          <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}
            alignItems={'center'}
            flexWrap={'nowrap'}
            gap={1}
          >
            <Typography className={classes?.label}>Sum Insured Type</Typography>
            <Box className={classes?.circleDot}></Box>
            <Typography className={classes?.value}>Family Package</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default PolicyDetailsCard
